import React from 'react';
import { Star } from 'lucide-react';
export function ResultsSection() {
  const results = [{
    desc: '$500+ first week revenue proof',
    image: 'https://cdn.magicpatterns.com/uploads/oqEBdbnpGmG5GQGmFcvjGg/8k_from_the_first_video_(11).png'
  }, {
    desc: '$113K total revenue proof',
    image: 'https://cdn.magicpatterns.com/uploads/8URXmgW4ewEyGyYRCsVxWp/8k_from_the_first_video_(9)_(1).png'
  }, {
    desc: '+5,480 subscribers growth proof',
    image: 'https://cdn.magicpatterns.com/uploads/qcfjLuaQVaNazfRLqvJbpy/8k_from_the_first_video_(6)_(1).png'
  }, {
    desc: '76K views in 24 hours proof',
    image: 'https://cdn.magicpatterns.com/uploads/e8eH7cfY1W7qd6wizmVJSy/Untitled_design_(10)_(1).png'
  }, {
    desc: '114K views proof',
    image: 'https://cdn.magicpatterns.com/uploads/eBTf3mBixvoaimuCwS9iQs/8k_from_the_first_video_(8).png'
  }, {
    desc: '$12K revenue proof',
    image: 'https://cdn.magicpatterns.com/uploads/3zsSRHJWckRCNzEpnq9S7S/8k_from_the_first_video_(12)_(1).png'
  }];
  return <section className="relative py-12 md:py-20 px-4 overflow-hidden" data-id="element-122">
      <div className="max-w-7xl mx-auto relative z-10" data-id="element-123">
        {/* Header */}
        <div className="text-center mb-8 md:mb-12" data-id="element-124">
          <div className="inline-flex items-center justify-center gap-2 mb-2 md:mb-3" data-id="element-125">
            <Star className="w-4 h-4 md:w-5 md:h-5 text-yellow-500 fill-yellow-500" data-id="element-126" />
            <h2 className="text-xl md:text-2xl lg:text-3xl font-extrabold text-white tracking-[-0.03em]" data-id="element-127">
              Real Results. Real Creators.
            </h2>
          </div>
          <p className="text-xs md:text-sm text-gray-400 max-w-lg mx-auto leading-relaxed tracking-[0.01em]" data-id="element-128">
            These numbers come from creators using our system. No face on
            camera, ever.
          </p>
        </div>

        {/* Grid - 1 col on mobile, 2 on tablet, 3 on desktop */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-5" data-id="element-129">
          {results.map((item, i) => <div key={i} className="overflow-hidden" data-id="element-130">
              <img src={item.image} alt={item.desc} className="w-full h-auto block" data-id="element-131" />
            </div>)}
        </div>
      </div>

      {/* Background decoration */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-purple-600/5 rounded-full blur-[120px] pointer-events-none -z-10" data-id="element-132" />
    </section>;
}